module.exports = __webpack_public_path__ + "img/equipment.33edddb9.svg";